<template>
<div class="row justify-content-md-center">
  <div class="text-left col-12 col-md-8">
    <div>
      <div class="row justify-content-md-center">
        <div class="col-12 col-md-6 text-center align-middle qr-container">
          <div class="d-flex align-items-center justify-content-center w-100">
            <qrcode-vue
              class="align-middle"
              v-bind:value="user.ordersDeepLinkUrl"
              size="150"
              level="H"
            />
          </div>
        </div>
      </div>
    </div>
    <ul class="details user-details">
      <li class="list-group-item col-md-12 user-name">
        <strong>{{ user.name }}</strong>
      </li>
      <li class="list-group-item">
        <strong>{{ user.document_number }}</strong>
      </li>
      <!-- <li class="list-group-item"><strong>Cliente: </strong>{{ user.company }}</li> -->
      <li class="list-group-item">
        Cupones:
        <strong>
          {{ couponsSummary.currentCredit }} / {{ couponsSummary.totalCredit}}
        </strong>
      </li>
    </ul>
  </div>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  name: "ProfileCard",
  props: ["user", "couponsSummary"],
  components: {
    QrcodeVue
  },
  created: function() {
    this.getSummary();
    this.getUserProfile();
  },
  methods: {
    getSummary: function() {
      this.$Progress.start();
      let url = this.$store.state.connection.url;
      this.$http
        .post(url + "coupons", {
          body: {}
        })
        .then(result => {
          this.$Progress.finish();
          let summary = {
            totalCoupons: result.body.result.total_coupons,
            totalCredit: result.body.result.total_credit,
            currentCredit: result.body.result.current_credit,
            rejectedOrders: result.body.result.rejected_orders
          };
          this.$store.commit("updateCouponsSummary", summary);
        })
        .catch(err => {
          console.log(err);
          this.$Progress.finish();
        });
    },
    getUserProfile: function() {
      this.$Progress.start();
      let url = this.$store.state.connection.url;
      this.$http
        .post(url + "profile", {
          body: {}
        })
        .then(result => {
          this.$Progress.finish();
          let profile = {
            username: result.body.result.username,
            documentNumber: result.body.result.doc_number,
            referredId: result.body.result.referred_id
          };
          this.$store.commit("refreshUser", profile);
        })
        .catch(err => {
          console.log(err);
          this.$Progress.finish();
        });
    }
  }
};
</script>

<style scoped>
.qr-container {
  display: flex;
  padding-top: 5%;
}
ul li {
  border: none;
  padding: 4px;
  margin-left: 0;
}
ul {
  margin-left: -15px;
  padding: 0;
  margin-top: 5px;
  font-size: 16px;
}
.user-details {
  text-align: center;
}
.user-name {
  max-height: 24px;
}
</style>
